import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { GetStudentTestResultsDto, StudentTestResultsResponse } from "../../interfaces/studentTestResult.interface";

export const studentTestResultApi = createApi({
  reducerPath: "studentTestResultApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/admin/student-test-results",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getStudentTestResults: build.query<StudentTestResultsResponse, Partial<GetStudentTestResultsDto>>({
      query: (params) => ({
        url: "/",
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useGetStudentTestResultsQuery } = studentTestResultApi;
